import { usePal, PalHead, PalIcon, SubHead } from "./PalUI";

const PalTeam = () => {
  const { c, brand, ink, muted, dim, hair, surface, isDark } = usePal();
  const t = c.team;
  return (
    <section aria-label={t.eyebrow} data-testid="pal-team">
      <PalHead
        eyebrow={t.eyebrow}
        title={t.title}
        accentLine={t.accentLine}
        action={
          <dl className="grid grid-cols-3 gap-6 md:gap-8" data-testid="pal-counters">
            {t.counters.map((x) => (
              <div key={x.label} className="flex flex-col-reverse">
                <dt className={`mt-1.5 text-[12px] font-medium ${dim}`}>{x.label}</dt>
                <dd className="text-[36px] font-semibold tracking-tight leading-none tabular-nums" style={{ color: brand }}>{x.value}</dd>
              </div>
            ))}
          </dl>
        }
      />
      <div className={`mt-8 pt-6 border-t grid grid-cols-1 lg:grid-cols-12 gap-10 ${hair}`}>
        <div className="lg:col-span-5 space-y-8">
          <ul className={`divide-y ${isDark ? "divide-white/10" : "divide-black/10"}`}>
            {t.people.map((p, i) => (
              <li key={p.name} className="py-3 flex items-start gap-3" data-testid={`pal-person-${i}`}>
                <span className="w-6 text-[20px] leading-none mt-0.5 flex-shrink-0" role="img" aria-label={p.location || p.name}>{p.flag}</span>
                <div className="min-w-0">
                  <div className={`text-[15px] font-semibold ${ink}`}>
                    {p.name} <span className="font-medium" style={{ color: brand }}>· {p.role}</span>
                  </div>
                  <div className={`text-[13px] ${muted}`}>{p.title}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-7 space-y-6">
          <div>
          <SubHead>Dedicated team</SubHead>
          <ul className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2.5" data-testid="pal-groups">
            {t.groups.map((g) => (
              <li key={g.name} title={g.roles} className={`rounded-xl border px-3 py-2.5 ${surface}`} data-testid={`pal-group-${g.iconName}`}>
                <PalIcon name={g.iconName} className="w-4 h-4" style={{ color: brand }} />
                <div className={`mt-2 text-[24px] font-semibold leading-none tabular-nums ${ink}`}>{g.count}</div>
                <div className={`mt-1 text-[12.5px] leading-snug ${muted}`}>{g.name}</div>
              </li>
            ))}
          </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PalTeam;
